import React from "react";
import PropTypes from "prop-types";

function StyledComponentPanel(props) {
  const { children, title } = props;
  return (
    <div className="tw-bg-white tw-border tw-border-blueGray-200 tw-relative">
      <div className="tw-border-b tw-border-blueGray-200 tw-p-3">{title}</div>
      {children}
    </div>
  );
}

StyledComponentPanel.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.node,
};

StyledComponentPanel.defaultProps = {
  title: "",
  children: null,
};

export default StyledComponentPanel;
